<template>
    <div class="page-wrapper">
        <div class="container-fluid">
            <div class="row ">
                <div class="col-lg-7 col-md-8 col-sm-10 mx-auto">
                    <div class="notification-card">
                        <div class="notification-head mb-3 d-flex gap-3 flex-wrap flex-md-nowrap">
                            <div
                                class="notification-icon d-flex justify-content-center align-items-center flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <g fill="none" fill-rule="evenodd">
                                        <path
                                            d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
                                        <path fill="currentColor"
                                            d="M5 9a7 7 0 0 1 14 0v3.764l1.822 3.644A1.1 1.1 0 0 1 19.838 18h-3.964a4.002 4.002 0 0 1-7.748 0H4.162a1.1 1.1 0 0 1-.984-1.592L5 12.764zm5.268 9a2 2 0 0 0 3.464 0zM12 4a5 5 0 0 0-5 5v3.764a2 2 0 0 1-.211.894L5.619 16h12.763l-1.17-2.342a2 2 0 0 1-.212-.894V9a5 5 0 0 0-5-5" />
                                    </g>
                                </svg>
                            </div>
                            <div class="notification-title">
                                <h1 class="mb-1">Email Notification</h1>
                                <p>
                                    Manage which notifications you want to receive. Turn them on
                                    or off anytime to stay updated without unnecessary alerts
                                </p>
                            </div>
                        </div>
                        <div class="notification_preference_wrapper">
                            <div class="select_category_wrapper">
                                <select name="" id="" class="form-select mt-2" @change="getMessageCenterList($event)">
                                    <option value="" selected disabled>Select Category</option>
                                    <option v-for="category in categoryList" :value="category.id" :key="category.id">{{ category.name }}</option>
                                </select>
                            </div>
                            <div class="selected_category_list mt-3" v-if="messageCenterList.length > 0">
                                <div class="selected_title_wrapper d-flex justify-content-between gap-3 align-items-center mb-4">
                                    <h6 class="title-wrapper mb-0">
                                        {{ selectedCategory }}
                                    </h6>
                                    <div class="toggle-switch switch-box ms-1">
                                        <label class="switch" for="invoice">
                                            <input type="checkbox" id="invoice" :checked="!isAnyUnsubscribed" @change="subscribeUnsubscribeAll($event)" />
                                            <div class="slider round"></div>
                                        </label>
                                    </div>
                                </div>
                                <ul class="listwrapper d-flex flex-column gap-4 mb-0">
                                    <li class="list_items d-flex" v-for="message in messageCenterList" :key="message.id">
                                        <div class="toggle-switch switch-box ms-1">
                                            <label class="switch" :for="`invoices`+message.id">
                                                <input type="checkbox" :id="`invoices`+message.id" :checked="!selectedEmailConfig.includes(message.id.toString())" @change="subscribeUnsubscribeManully($event,message.id)" />
                                                <div class="slider round"></div>
                                            </label>
                                        </div>
                                        {{ message.label }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from '../resource/Api';

export default {
    name: "Notification",
    data() {
        return {
            categoryList: [],
            messageCenterList: [],
            selectedCategory: null,
            selectedEmailConfig: [],
            isAnyUnsubscribed: false,
        };
    },
    mounted() {
        this.getCategoryList();
    },
    computed: {
        authEmail() {
            return this.$store.getters.repEmail;
        }
    },
    methods: {
        getCategoryList() {
            const url = 'v1/message-center/categories';
            let loader = this.$loading.show();
            Api.get(url).then(({ data }) => {
                this.categoryList = data.data.data;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                loader.hide();
            })
        },
        getMessageCenterList(event) {
            let loader = this.$loading.show();
            const categoryId = event.target.value;
            this.selectedCategoryId = categoryId;
            this.selectedCategory = event.target.options[event.target.selectedIndex].text;
            const url = `v1/message-center/categories/${categoryId}/email-configurations`;
            this.messageCenterList = [];
            Api.get(url).then(({ data }) => {
                const responseData = data.data;
                this.messageCenterList = responseData.data;
                this.selectedEmailConfig = responseData.selected_email_configs.map(String);
                this.checkAllSubscribedStatus();
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                loader.hide();
            });
        },
        checkAllSubscribedStatus() {
            const checkUnsuscrbtionEmailConfigExist = this.messageCenterList.filter((data) => {
                return this.selectedEmailConfig.includes(data.id.toString());
            })
            this.isAnyUnsubscribed = checkUnsuscrbtionEmailConfigExist.length > 0;
        },
        async subscribeUnsubscribeAll(event) {
            let loader = this.$loading.show();
            const isToggleOn = event.target.checked;
            let tempUnsubscribedIdList = [...this.selectedEmailConfig];
            if(isToggleOn) {
                const currentSubCategoryIds = this.messageCenterList.map((data) => data.id.toString());
                tempUnsubscribedIdList = tempUnsubscribedIdList.filter((id) => {
                    return !currentSubCategoryIds.includes(id.toString());
                });
                await this.subscribe();
            } else {
                this.messageCenterList.forEach((data) => {
                    tempUnsubscribedIdList.push(data.id.toString());
                });

                const subCategoriesId = this.messageCenterList.map(item => item.id.toString());
                await this.unsubscribe(subCategoriesId);
            }
            this.selectedEmailConfig = tempUnsubscribedIdList;
            loader.hide();
        },
        async subscribeUnsubscribeManully(event,id) {
            let loader = this.$loading.show();
            const isToggleOn = event.target.checked;
            const currentToggledSubCat = this.messageCenterList.filter((data) => {return data.id==id});
            if(isToggleOn) {
                const index = this.selectedEmailConfig.indexOf(id.toString());
                if (index !== -1) {
                    this.selectedEmailConfig.splice(index, 1);
                    await this.subscribe(this.selectedEmailConfig, currentToggledSubCat[0].label);
                }
            } else {
                this.selectedEmailConfig.push(id.toString());
                await this.unsubscribe(this.selectedEmailConfig, currentToggledSubCat[0].label)
            }
            this.checkAllSubscribedStatus();
            loader.hide();
        },
        async subscribe(subCategoriesId=[], hasLabel="") {
            const baseUrl = 'v1/message-center/update-subscription';
            const payload = {
                email: this.authEmail,
                categories_id: this.selectedCategoryId.toString(),
                status: 0,
                sub_categories_id: subCategoriesId
            };

            await this.apiRequest(baseUrl, payload, hasLabel, 'enabled');
        },
        async unsubscribe(subCategoriesId, hasLabel="") {
            const baseUrl = 'v1/message-center/unsubscribe-user';
            const payload = {
                email: this.authEmail,
                categories_id: this.selectedCategoryId.toString(),
                reason: "manually unsubscribed",
                description: "",
                sub_categories_id: subCategoriesId
            };

            await this.apiRequest(baseUrl, payload, hasLabel, 'disabled');
        },
        async apiRequest(baseUrl, payload, hasLabel, status) {
            try {
                let statusFor = this.selectedCategory;
                if(hasLabel!=="") {
                    statusFor = hasLabel;
                }
                const responseData = await Api.post(baseUrl, payload);
                if(responseData.status==200) {
                    const apiResponseMessage = `Successfully ${status} notifications for ${statusFor}`;
                    this.$notify(
                        apiResponseMessage,
                        "success"
                    );
                } else {
                    this.$notify('Something Went Wrong!', "error");
                }
            } catch (err) {
                console.error('Error:', err.response?.data || err.message);
                this.$notify(
                    err.message,
                    "error"
                );
            }
        }
    },
};
</script>
<style src="@/assets/css/notification.css" scoped></style>
